/**
 * Jauge de créneaux de chantier : un pip par créneau (rempli = occupé), plus un
 * décompte lisible d'un coup d'œil. Miroir volontaire de `ShipyardSlots`
 * (Shipyard.tsx) pour ne pas inventer un second langage d'UI : le joueur a déjà
 * appris à lire cette jauge au Chantier naval.
 *
 * Les créneaux sont ouverts par le niveau du Quartier-Général (le 2e au QG 18).
 * Tant que le joueur n'en a qu'un, la jauge ne s'affiche PAS du tout : rien n'a
 * changé pour lui, et l'UI n'a aucune raison de lui parler d'une mécanique de
 * fin de partie.
 */
export function ConstructionSlots({ used, total }: { used: number; total: number }) {
  if (total <= 1) return null

  const free = Math.max(0, total - used)
  return (
    <span className="inline-flex items-center gap-2 text-sm" title={`${used}/${total} créneau(x) de chantier occupé(s)`}>
      <span className="inline-flex items-center gap-1">
        {Array.from({ length: total }, (_, i) => (
          <span
            key={i}
            data-slot={i < used ? 'busy' : 'free'}
            className={`w-3.5 h-3.5 rounded-sm border ${
              i < used ? 'bg-sand-300/70 border-sand-300' : 'border-sand-500/40 bg-ocean-900/40'
            }`}
          />
        ))}
      </span>
      <span className={`font-medium ${free > 0 ? 'text-green-300' : 'text-red-400'}`}>
        {free > 0 ? `${free} créneau${free > 1 ? 'x' : ''} libre${free > 1 ? 's' : ''}` : 'Tous les créneaux sont occupés'}
      </span>
    </span>
  )
}
